// The calendar arithmetic behind the date picker. Dates are the family's partial dates: "1987", "1987-06" or
// "1987-06-12", as rough as anyone knows them.

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const pad = (n: number) => String(n).padStart(2, '0')

export function partialDate(year: number, month?: number, day?: number) {
  if (!month) return String(year)
  return day ? `${year}-${pad(month)}-${pad(day)}` : `${year}-${pad(month)}`
}

export function readDate(value: string | null | undefined) {
  const [y, m, d] = (value ?? '').split('-').map(Number)
  return { year: y || null, month: m || null, day: d || null }
}

export const daysIn = (year: number, month: number) => new Date(Date.UTC(year, month, 0)).getUTCDate()

// A month laid out by week, Sunday first: blanks (null) before the 1st, then each day.
export function monthGrid(year: number, month: number): (number | null)[] {
  const lead = new Date(Date.UTC(year, month - 1, 1)).getUTCDay()
  return [...Array<null>(lead).fill(null), ...Array.from({ length: daysIn(year, month) }, (_, i) => i + 1)]
}

// Years come twelve to a page, and the newest page ends on this year.
export function yearPage(year: number, thisYear: number) {
  const start = thisYear - 11 - Math.ceil((thisYear - year - 11) / 12) * 12
  return Array.from({ length: 12 }, (_, i) => start + i)
}
